import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const InquiryPage = lazy(() => import('@/pages/cs/inquiry/InquiryPage.tsx'))
const InquiryDetailPage = lazy(() => import('@/pages/cs/inquiry/InquiryDetailPage'))
const NoticePage = lazy(() => import('@/pages/cs/notice/NoticePage'))
const NoticeAddPage = lazy(() => import('@/pages/cs/notice/NoticeAddPage'))
const NoticeDetailPage = lazy(() => import('@/pages/cs/notice/NoticeDetailPage'))
const FaqPage = lazy(() => import('@/pages/cs/faq/FaqPage'))

/**
 * 유저지원 관리 라우트
 * - 온라인 문의
 * - 공지사항
 * - FAQ
 */

export const csRoutes: RouteWithMeta = {
  path: 'cs',
  meta: {
    label: '유저지원',
    showInMenu: true,
    icon: ''
  },
  children: [
    // ===== 온라인 문의 =====
    {
      path: 'inquiry',
      element: withSuspense(<InquiryPage/>),
      meta: {
        label: '온라인 문의',
        showInMenu: true,
      }
    },
    {
      path: 'inquiry/:id',
      element: withSuspense(<InquiryDetailPage/>),
      meta: {
        label: '온라인 문의 상세',
        showInMenu: false,
      }
    },

    // ===== 공지사항 =====
    {
      path: 'notice',
      element: withSuspense(<NoticePage/>),
      meta: {
        label: '공지사항',
        showInMenu: true,
      }
    },
    {
      path: 'notice/add',
      element: withSuspense(<NoticeAddPage/>),
      meta: {
        label: '공지사항 등록',
        showInMenu: false
      }
    },
    {
      path: 'notice/:id',
      element: withSuspense(<NoticeDetailPage/>),
      meta: {
        label: '공지사항 상세',
        showInMenu: false
      }
    },

    // ===== FAQ =====
    {
      path: 'faq',
      element: withSuspense(<FaqPage/>),
      meta: {
        label: 'FAQ',
        showInMenu: true,
      }
    },
  ]
}